import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import LeadSummary from './LeadSummary'
import LeadStatusControl from './LeadStatusControl'
import { fmt } from './LeadTimeline'

/** Lead detail panel: a slide-over opened from the leads list, so a lead can be reviewed and updated without leaving the list. */
export default function LeadDetailPanel({ lead, onClose, onUpdated }) {
  const ref = useRef(null)
  useEffect(() => {
    const previous = document.activeElement
    if (ref.current) ref.current.focus()
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    return () => { document.removeEventListener('keydown', onKey); if (previous && previous.focus) previous.focus() }
  }, [onClose])

  return (
    <div className="lead-panel-backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <aside className="lead-panel" role="dialog" aria-modal="true" aria-label={`Lead details: ${lead.name}`} tabIndex={-1} ref={ref}>
        <header className="lead-panel__head">
          <h2 className="h5 mb-0">Lead details</h2>
          <button type="button" className="btn-close" aria-label="Close lead details" onClick={onClose} />
        </header>
        <div className="lead-panel__body">
          <LeadSummary lead={lead} />
          <div className="mt-3"><LeadStatusControl key={`${lead.id}:${lead.status}`} lead={lead} onUpdated={onUpdated} /></div>
          <h3 className="h6 mt-4 mb-2">Timeline</h3>
          {lead.timeline && lead.timeline.length ? (
            <div className="timeline">{lead.timeline.map((e, i) => <div className="ev" key={i}><small className="text-muted">{fmt(e.at)}</small><div>{e.event}</div></div>)}</div>
          ) : <div className="text-muted small">No activity yet.</div>}
        </div>
        <footer className="lead-panel__foot">
          <Link className="btn btn-primary btn-sm" to={`/leads/${lead.id}`}>Open full page to edit</Link>
          <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClose}>Close</button>
        </footer>
      </aside>
    </div>
  )
}
